<div class="main-screen-container">
    <div class="top-row">
        <button mat-flat-button class="btn-action btn-with-icon" color="accent"
            (click)="router.navigate(['organizations-list'])"><img style="width:25px;" src="/assets/img/back.png"
                alt="">Powrót</button>
    </div>
    <div class="list-container">
        <div class="add-form">
            <h3>Dodaj organizację</h3>
            <form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-layout">
                <mat-form-field appearance="outline" style="width:100%;">
                    <mat-label>Nazwa</mat-label>
                    <input matInput type="text" placeholder="Nazwa" required formControlName="name">
                </mat-form-field>
                <mat-form-field appearance="outline" style="width:100%;">
                    <mat-label>Adres</mat-label>
                    <input matInput type="adres" placeholder="Adres" required formControlName="address">
                </mat-form-field>
                <mat-form-field appearance="outline" style="width:100%;">
                    <mat-label>NIP</mat-label>
                    <input matInput type="text" placeholder="NIP" required formControlName="NIP">
                </mat-form-field>

                <button mat-flat-button class="btn-action btn-large" color="accent">Dodaj</button>
            </form>
        </div>
    </div>
    <div style="height:50px">

    </div>
</div>